import React from "react"
import Container from "../Container"
import { Props } from "./props"
import "../../../styles/full_height"

const ShelterLamp: React.FC<Props> = (props) => (
  <Container contentType="shelterLamp" {...props} />
)
export default ShelterLamp
